module.exports = __webpack_public_path__ + "img/Stemness-PDAC_GSE205354.7c23fca8.png";